import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Datenschutz = () => {
  return (
    <main className="pt-16 lg:pt-20">
      <section className="section-padding bg-white" data-testid="datenschutz-page">
        <div className="container-main">
          <div className="max-w-3xl mx-auto">
            <Link to="/" className="inline-flex items-center gap-2 text-slate-500 hover:text-[#0F172A] mb-8 transition-colors">
              <ArrowLeft className="w-4 h-4" />
              <span className="text-sm">Zurück zur Startseite</span>
            </Link>

            <h1 className="heading-lg text-[#0F172A] mb-8" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Datenschutzerklärung
            </h1>

            <div className="prose prose-slate max-w-none">
              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                1. Allgemeine Hinweise
              </h2>
              <p className="text-slate-600 mb-4">
                Wir freuen uns über Ihr Interesse an unserer Website. Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Nachfolgend informieren wir Sie darüber, welche Daten wir erheben, wie wir diese nutzen und welche Rechte Sie in Bezug auf Ihre Daten haben.
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                2. Verantwortlicher gemäß Art. 4 Abs. 7 DSGVO
              </h2>
              <p className="text-slate-600 mb-4">
                DSG Beteiligungs- und Verwaltungsgesellschaft mbH
              </p>
              <p className="text-slate-600 mb-4">
                Telefon:<br />
                Mobil: +49 176 93127245<br />
                Festnetz: +49 30 71047955
              </p>
              <p className="text-slate-600 mb-4">
                E-Mail: <a href="mailto:info@hospital-bess.de" className="text-[#10B981] hover:underline">info@hospital-bess.de</a>
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                3. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck der Verarbeitung
              </h2>

              <h3 className="text-lg font-semibold text-[#0F172A] mt-6 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
                3.1 Beim Besuch der Website
              </h3>
              <p className="text-slate-600 mb-4">
                Beim Aufrufen unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser automatisch Informationen an unseren Server gesendet. Diese Informationen werden temporär in einem sogenannten Logfile gespeichert.
              </p>
              <p className="text-slate-600 mb-4">
                Folgende Daten können dabei erfasst werden:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-1">
                <li>IP-Adresse des anfragenden Geräts</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Name und URL der abgerufenen Datei</li>
                <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
                <li>verwendeter Browser und ggf. das Betriebssystem Ihres Endgeräts</li>
              </ul>
              <p className="text-slate-600 mb-4">
                Diese Daten werden zu folgenden Zwecken verarbeitet:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-1">
                <li>Gewährleistung eines reibungslosen Verbindungsaufbaus der Website</li>
                <li>Auswertung der Systemsicherheit und -stabilität</li>
                <li>administrative Zwecke</li>
              </ul>
              <p className="text-slate-600 mb-4">
                Rechtsgrundlage: Art. 6 Abs. 1 S. 1 lit. f DSGVO.
              </p>
              <p className="text-slate-600 mb-4">
                <strong>Hosting erfolgt bei:</strong>
              </p>
              <p className="text-slate-600 mb-4">
                STRATO AG<br />
                Otto-Ostrowski-Straße 7<br />
                10249 Berlin<br />
                Deutschland
              </p>
              <p className="text-slate-600 mb-4">
                Mit dem Hostinganbieter besteht ein Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO.
              </p>

              <h3 className="text-lg font-semibold text-[#0F172A] mt-6 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
                3.2 Nutzung des Kontaktformulars
              </h3>
              <p className="text-slate-600 mb-4">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Formular (Name, Firma, E-Mail-Adresse, Telefonnummer und Nachricht) zur Bearbeitung der Anfrage und für mögliche Anschlussfragen gespeichert.
              </p>
              <p className="text-slate-600 mb-4">
                Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
              </p>
              <p className="text-slate-600 mb-4">
                Sie können diese Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns.
              </p>

              <h3 className="text-lg font-semibold text-[#0F172A] mt-6 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
                3.3 Cookies
              </h3>
              <p className="text-slate-600 mb-4">
                Unsere Website verwendet ausschließlich technisch notwendige Cookies.
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                4. Weitergabe von Daten
              </h2>
              <p className="text-slate-600 mb-4">
                Eine Übermittlung Ihrer persönlichen Daten an Dritte findet grundsätzlich nicht statt, außer wenn:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-1">
                <li>Sie Ihre ausdrückliche Einwilligung erteilt haben (Art. 6 Abs. 1 lit. a DSGVO)</li>
                <li>eine rechtliche Verpflichtung besteht (Art. 6 Abs. 1 lit. c DSGVO)</li>
                <li>die Verarbeitung zur Vertragserfüllung erforderlich ist (Art. 6 Abs. 1 lit. b DSGVO)</li>
              </ul>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                5. Ihre Rechte als betroffene Person
              </h2>
              <p className="text-slate-600 mb-4">
                Sie haben folgende Rechte:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-1">
                <li>Auskunft (Art. 15 DSGVO)</li>
                <li>Berichtigung (Art. 16 DSGVO)</li>
                <li>Löschung (Art. 17 DSGVO)</li>
                <li>Einschränkung (Art. 18 DSGVO)</li>
                <li>Widerspruch (Art. 21 DSGVO)</li>
                <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
              </ul>
              <p className="text-slate-600 mb-4">
                Widerruf der Einwilligung: jederzeit möglich.
              </p>
              <p className="text-slate-600 mb-4">
                Sie haben außerdem das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                6. Speicherdauer
              </h2>
              <p className="text-slate-600 mb-4">
                Wir speichern personenbezogene Daten nur so lange, wie es für die genannten Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                7. Datensicherheit
              </h2>
              <p className="text-slate-600 mb-4">
                Wir setzen geeignete technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen Manipulation, Verlust oder unbefugten Zugriff zu schützen.
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                8. Änderungen dieser Datenschutzerklärung
              </h2>
              <p className="text-slate-600 mb-4">
                Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf zu aktualisieren.
              </p>

              <p className="text-slate-500 text-sm mt-12 pt-8 border-t border-slate-200">
                © 2026 DSG Beteiligungs- und Verwaltungsgesellschaft mbH — Design & Umsetzung: webionik
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
